import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { updateAction } from '@/redux/nodes/actions';
import { AIResponseSubAgentConfig, SubAgentAction } from '@/shared/types/action';

/**
 * Adapts a `sub_agent` action carrying a ai_response config to a simple
 * `{ guidelines, onGuidelinesChange }` contract. The discriminator
 * (`type: 'ai_response'`) is preserved on write.
 */
export const useAIResponseSubAgentConfig = (actionId: string, action: SubAgentAction) => {
  const dispatch = useDispatch();
  const config = action.sub_agent_config as AIResponseSubAgentConfig;
  const guidelines = config?.guidelines ?? '';

  const onGuidelinesChange = useCallback(
    (next: string) => {
      const nextConfig: AIResponseSubAgentConfig = { type: 'ai_response', guidelines: next };
      dispatch(updateAction({ actionId, action: { ...action, sub_agent_config: nextConfig } }));
    },
    [action, actionId, dispatch]
  );

  return { guidelines, onGuidelinesChange };
};
